/**
 * Copyright (c) 2018 Mathis Zeiher
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */

/**
 * COMPONENT_STATE
 */
export let COMPONENT_STATE;

(function (COMPONENT_STATE) {
  COMPONENT_STATE[COMPONENT_STATE["CONNECTED"] = 0] = "CONNECTED";
  COMPONENT_STATE[COMPONENT_STATE["DISCONNECTED"] = 1] = "DISCONNECTED";
  COMPONENT_STATE[COMPONENT_STATE["INIT"] = 2] = "INIT";
  COMPONENT_STATE[COMPONENT_STATE["CONSTRUCTED"] = 3] = "CONSTRUCTED";
})(COMPONENT_STATE || (COMPONENT_STATE = {}));
